import React, { useEffect, useState } from 'react'
import { Text, View } from 'react-native'
import { Divider } from 'react-native-paper'
import { SearchBarWithPlaceholder } from '../atoms/SearchBarWithPlaceholder'
import { Spacer } from '../atoms'
import { useNavigation } from '@react-navigation/core'
import { TouchableOpacity } from 'react-native-gesture-handler'
import { useInvoiceDetailsContext } from '../../screens/Contractor/TabInvoice/InvoiceDetailsContext'
import { routes } from '@linqpal/models'
import { AddFolder } from '../../assets/icons'
import { CustomIconFAB } from '../atoms/CustomIconFAB'
import { useStore } from '../../store'
import { isWeb } from '../../utils/helpers/commonUtils'
import cookies from '../../utils/service/cooker'
import BuilderBottomModal from '../molecules/BuilderBottomModal'
import { paths } from '../../screens/links'
import { useResponsive } from '../../utils/hooks'

export const ProjectSelectionBottomModal = ({ invoice }) => {
  const [projects, setProjects] = useState([])
  const { md } = useResponsive()

  const { userStore } = useStore()

  const [searchQuery, setSearchQuery] = useState('')

  const {
    projectSelectionModalVisibility,
    setProjectSelectionModalVisibility,
    setAddProjectSuccessModalVisibility,
    setSelectedProject,
  } = useInvoiceDetailsContext()

  const isUserAuthenticated = isWeb
    ? !!cookies.get('session')
    : userStore.isUserAuthenticated

  useEffect(() => {
    if (isUserAuthenticated) {
      const req = routes.projects.list({})
      req.then((res) => {
        setProjects(res.projects)
      })
    }
  }, [projectSelectionModalVisibility])

  const navigation = useNavigation()

  const onProjectPress = async (project) => {
    routes.projects
      .add(invoice._id, project._id, invoice.project?._id)
      .then((res) => {
        setSelectedProject(res.project)
        setProjectSelectionModalVisibility(false)
        setAddProjectSuccessModalVisibility(true)
      })
      .catch((err) => {
        console.log(err)
      })
  }
  const onClose = () => {
    setProjectSelectionModalVisibility(false)
    navigation.replace(paths.Home._self, {
      screen: paths.Console.Payables._self,
      params: { screen: paths.Console.Payables.home },
    })
  }

  return (
    <BuilderBottomModal
      visible={projectSelectionModalVisibility}
      title={'Choose a Project'}
      subtitle="Add to an existing or new project"
      fixedContent={
        <View style={{ paddingBottom: 8 }}>
          <SearchBarWithPlaceholder
            value={searchQuery}
            onChangeText={setSearchQuery}
            placeholder={'Search for project name'}
          />
        </View>
      }
      onClose={onClose}
      height={500}
    >
      <Spacer height={20} />
      {projects
        .filter((project) =>
          project.name.toLowerCase().includes(searchQuery.toLowerCase()),
        )
        .map((project, index) => (
          <View key={index}>
            <TouchableOpacity onPress={() => onProjectPress(project)}>
              <Text>{project.name}</Text>
            </TouchableOpacity>
            <Divider style={{ marginVertical: 20 }} />
          </View>
        ))}
      <CustomIconFAB
        onPress={() => {
          setProjectSelectionModalVisibility(false)
          if (md) {
            navigation.replace(paths.Home._self, {
              screen: paths.Console.Projects._self,
              params: { screen: paths.Console.Projects.Form },
            })
          } else {
            navigation.replace(paths.Home._self, {
              screen: paths.Console.More._self,
              params: {
                screen: paths.Console.Projects._self,
                params: {
                  screen: paths.Console.Projects.Form,
                  params: { invoice },
                },
              },
            })
          }
        }}
        iconOffsetBottom={7}
        iconOffsetLeft={3}
        icon={<AddFolder />}
      />
    </BuilderBottomModal>
  )
}
